<template>
  <div class="app-container">
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form" label-width="110px" size="mini">
        <div class="">
          <el-form-item label="业务类型:">
            <el-select size="mini" v-model="searchForm.businessType" placeholder="请选择业务类型" allow-create filterable clearable>
              <el-option v-for="(item, index) in businessList" :label="item.label" :key="index" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="启用状态:">
            <el-select size="mini" v-model="searchForm.enableStatus" placeholder="请选择启用状态" clearable>
              <el-option v-for="(item, index) in enableList" :label="item.label" :key="index" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发货单位名称:">
            <el-select v-model="searchForm.deliveryCompanyName" size="mini" placeholder="请选择发货单位名称" filterable clearable>
              <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
                :value="item.custerName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="收货单位名称:">
            <el-select v-model="searchForm.receiveCompanyName" size="mini" placeholder="请选择收货单位名称" filterable clearable>
              <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
                :value="item.custerName"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="searchBtnBox">
          <el-form-item>
            <el-button type="primary" class="allBtn" @click="searchFn">查询</el-button>
            <el-button type="primary" class="allBtn" @click="resetForm('searchForm')">重置</el-button>
            <el-button type="primary" class="allBtn" @click="addMaterial">新增</el-button>
            <el-button type="primary" class="allBtn" @click="delMaterial(1)">删除</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="primary" class="allBtn" @click="addMaterial" btnCode="00ZP00GB001" v-if="btnFlg[0]">新增</el-button>
          </el-form-item> -->
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }">
      <el-table :data="tableList" ref="table" bordersize="mini" height="100%" style="width: 100%" class="tableComent" @selection-change="handleSelectionChange" @row-click="rowClick" highlight-current-row center border>
  <el-table-column type="selection" width="55"></el-table-column>
  <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
  <el-table-column width="180" label="操作">
    <template slot-scope="scope">
      <div>
        <el-button type="text" size="mini" @click="editMaterial(scope.row)">修改</el-button>
        <el-button type="text" size="mini" @click="delMaterial(2,scope.row)">删除</el-button>
        <el-button type="text" size="mini" @click="qiYongClick(scope.row)" v-if="scope.row.enableStatus=='1'">停用</el-button>
        <el-button type="text" size="mini" @click="qiYongClick(scope.row)" v-if="scope.row.enableStatus=='2'">启用</el-button>
      </div>
    </template>
  </el-table-column>
  <el-table-column prop="planNo" width="160" label="计划编号"></el-table-column>
  <el-table-column prop="businessType" width="120" label="业务类型">
    <template slot-scope="scope">
      <span>{{ scope.row.businessType == 1 ? "入库计划" : "出库计划" }}</span>
    </template>
  </el-table-column>
  <el-table-column prop="productType" width="120" label="货物类型" show-overflow-tooltip></el-table-column>
  <el-table-column prop="planWeight" width="100" label="计划量"></el-table-column>
  <el-table-column prop="transportWeight" width="100" label="拉运量">
    <template slot-scope="scope">
      <div>
        <span v-if="scope.row.transportWeight > 0" style="color: #0c46a2;cursor: pointer;" @click="transportFn(scope.row)">{{scope.row.transportWeight}}</span>
        <span style="color: #0c46a2;" v-else>{{scope.row.transportWeight}}</span>
      </div>
    </template>
  </el-table-column>
  <el-table-column prop="enableStatus" width="100" label="启用状态">
    <template slot-scope="scope">
      <span>{{ scope.row.enableStatus == 1 ? "启用" : "停用" }}</span>
    </template>
  </el-table-column>
  <!-- 发货信息 -->
  <el-table-column prop="deliveryCompanyName" width="220" label="发货单位名称" show-overflow-tooltip></el-table-column>
  <el-table-column prop="deliveryContact" width="120" label="发货联系人" show-overflow-tooltip></el-table-column>
  <el-table-column prop="deliveryPhone" width="130" label="发货电话"></el-table-column>
  <el-table-column prop="deliveryAddress" width="280" label="发货地址" show-overflow-tooltip></el-table-column>
  <!-- 收货信息 -->
  <el-table-column prop="receiveCompanyName" width="220" label="收货单位名称" show-overflow-tooltip></el-table-column>
  <el-table-column prop="receiveContact" width="120" label="收货联系人" show-overflow-tooltip></el-table-column>
  <el-table-column prop="receivePhone" width="130" label="收货电话"></el-table-column>
  <el-table-column prop="receiveAddress" width="280" label="收货地址" show-overflow-tooltip></el-table-column>
  <!-- 其他补充字段 -->
  <el-table-column prop="checkLoad" width="130" label="是否校验装卸">
    <template slot-scope="scope">
      <div>
        <span v-if="scope.row.checkLoad == 1">校验</span>
        <span v-if="scope.row.checkLoad == 2">不校验</span>
        <span v-if="!scope.row.checkLoad">-</span>
      </div>
    </template>
  </el-table-column>
  <el-table-column prop="beginDate" width="180" :formatter="dateTimeFormat" label="开始时间"></el-table-column>
  <el-table-column prop="endDate" width="180" :formatter="dateTimeFormat" label="截止时间"></el-table-column>
</el-table>
    </div>
    <!-- 分页-->
    <div>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchForm.pageNo" :page-sizes="[10, 20, 25, 50, 100]" :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <!-- 新增 -->
    <el-dialog :title="title" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogVisible" @close="close" center width="900px">
      <el-form :rules="rules" :model="addForm" :validate-on-rule-change="false" ref="addForm" class="demo-form-inline" label-width="150px" :inline="true" size="small" v-if="dialogVisible">
        <div class="addinpBox">
          <el-form-item label="业务类型:" prop="businessType">
            <el-select size="mini" v-model="addForm.businessType" placeholder="请选择业务类型" allow-create filterable clearable>
              <el-option v-for="(item, index) in businessList" :label="item.label" :key="index" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="启用状态:" prop="enableStatus">
            <el-select size="mini" v-model="addForm.enableStatus" placeholder="请选择启用状态" clearable>
              <el-option v-for="(item, index) in enableList" :label="item.label" :key="index" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="货物类型:" prop="productType">
            <el-select filterable clearable v-model="addForm.productType" size="mini" placeholder="请选择货物类型">
              <el-option v-for="(item, index) in huowuOptions" :key="index" :label="item.name"
                :value="item.name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="计划量:" prop="planWeight">
            <el-input size="mini" placeholder="请输入计划量" maxlength="100" v-number-input.float="3" v-model.trim="addForm.planWeight"></el-input>
          </el-form-item>
          <el-form-item label="发货单位名称:" prop="deliveryCompanyName">
            <el-select v-model="addForm.deliveryCompanyName" size="mini" placeholder="请选择发货单位名称" filterable clearable>
              <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
                :value="item.custerName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发货联系人:" prop="deliveryContact">
            <el-input  placeholder="" size="mini" maxlength="20"  v-model="addForm.deliveryContact"></el-input>
          </el-form-item>
          <el-form-item label="发货电话:" prop="deliveryPhone">
            <el-input  placeholder="" size="mini" maxlength="11"  v-model="addForm.deliveryPhone"></el-input>
          </el-form-item>
          <el-form-item label="发货省市县:" class="diqu is-required"  prop="qishidi">
            <shengShiXian :rowData="qishidi"  @handleChange="handleChange" v-if="dialogVisible"></shengShiXian>
          </el-form-item>
           <el-form-item label="发货地址:" prop="deliveryAddress">
            <el-input  placeholder="" maxlength="100" size="mini"  style="width: 583px;"  v-model="addForm.deliveryAddress"></el-input>
          </el-form-item>
          <el-form-item label="收货单位名称:" prop="receiveCompanyName">
            <el-select v-model="addForm.receiveCompanyName" size="mini" placeholder="请选择收货单位名称" filterable clearable>
              <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
                :value="item.custerName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="收货联系人:" prop="receiveContact">
            <el-input  placeholder="" size="mini" maxlength="20"  v-model="addForm.receiveContact"></el-input>
          </el-form-item>
          <el-form-item label="收货电话:" prop="receivePhone">
            <el-input  placeholder="" size="mini" maxlength="11"  v-model="addForm.receivePhone"></el-input>
          </el-form-item>
           <el-form-item label="收货省市县:" class="diqu is-required"  >
            <shengShiXian :rowData="mudidi" @handleChange="handleChange1" v-if="dialogVisible"></shengShiXian>
          </el-form-item>
           <el-form-item label="收货地址:" prop="receiveAddress">
            <el-input  placeholder="" size="mini" maxlength="100"  style="width: 583px;"   v-model="addForm.receiveAddress"></el-input>
          </el-form-item>
          <el-form-item label="是否校验装卸:" prop="checkLoad">
            <el-select v-model="addForm.checkLoad" size="mini" placeholder="请选择是否校验装卸" clearable>
              <el-option v-for="(item, index) in checkList" :key="index" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间:" prop="beginDate">
            <el-date-picker  v-model="addForm.beginDate" size="mini"  format="yyyy-MM-dd HH:mm:ss"  value-format="timestamp"
              type="datetime" ></el-date-picker>
          </el-form-item>
          <el-form-item label="截止时间:" prop="endDate">
            <el-date-picker  v-model="addForm.endDate" size="mini"  format="yyyy-MM-dd HH:mm:ss"  value-format="timestamp"
              type="datetime" ></el-date-picker>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="saveFn" v-show="addBtnShow" :loading="addLoading">保 存</el-button>
        <el-button type="primary" size="mini" @click="saveFn" v-show="changeBtnShow" :loading="addLoading">修 改</el-button>
        <el-button @click="close" size="mini">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 拉运量详情 -->
    <el-dialog title="拉运量详情" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="transportVisible" @close="transportClose" center width="80%">
      <div class="addinpBox">
        <el-table :data="laYunDataList" ref="table" bordersize="mini" style="width: 100%" height="100%" center border>
          <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="deliveryCompanyName" label="发货单位" align="center" width="200"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="receiveCompanyName" label="收货单位" align="center" width="200"></el-table-column>
          <el-table-column property="jobType" label="作业类型" width="100">
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.jobType == '卸货'">入库卸货</span>
                <span v-if="scope.row.jobType == '装货'">出库装货</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column property="queueName" label="队列" width="180"></el-table-column>
          <el-table-column prop="vehicleNo" label="车牌号" width="100"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="mobilePhone" label="手机号" align="center" width="120"></el-table-column>
          <el-table-column prop="jobStatusName" label="作业类型" width="120">
            <template slot-scope="scope">
              <div>
                <!-- 1：排队中 2：已叫号 3：已过号 4：已失效 5：已进仓 6：进仓过磅完成 7：出仓过主磅完成 8：出仓过副磅完成 9：已出仓 -->
                <span v-if="scope.row.jobStatusName == '排队中'" style="color:blue">排队中</span>
                <span v-else-if="scope.row.jobStatusName == '已叫号'" style="color:red">已叫号</span>
                <span v-else-if="scope.row.jobStatusName == '已过号'" style="color:rgb(242, 159, 25)">已过号</span>
                <span v-else>{{ scope.row.jobStatusName }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="productType" label="货物类型" width="120"></el-table-column>
          <el-table-column prop="warehouseName" label="仓位" align="center" width="80"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="entryWeighing" label="进仓过磅重量(吨)" align="center" width="150"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="exitMainWeighing" label="出仓过磅重量(吨)" align="center" width="150"></el-table-column>
          <el-table-column width="160" prop="registrationTime" label="登记时间" :formatter="dateTimeFormat"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="callStationTime" label="叫号时间" align="center" width="160" :formatter="dateTimeFormat"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="mobilizationTime" label="进仓时间" align="center" width="160" :formatter="dateTimeFormat"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="entryWeighingTime" label="进仓过磅时间" align="center" width="160" :formatter="dateTimeFormat"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="exitMainTime" label="出仓过磅时间" align="center" width="160" :formatter="dateTimeFormat"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="exFactoryTime" label="出仓时间" align="center" width="160" :formatter="dateTimeFormat"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="no" label="业务单号" align="center" width="200"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="originalTon" label="装货地净重" align="center" width="110"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="grossWeight" label="装货地毛重" align="center" width="110"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="tareWeight" label="装货地皮重" align="center" width="110"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="unloadUser" label="装卸人" align="center" width="140"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="unloadTime" label="装卸时间" align="center" width="170" :formatter="dateTimeFormat"></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="transportClose" size="mini">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import {
  findPlanOrderList, // 查询
  addPlanOrder, // 新增
  updatePlanOrder, // 修改
  deletePlanOrder, // 删除
  enablePlanOrder, // 停/启用
  findSaForPlanList
} from '@/api/lj'
import {
  getVirtualBalingList,
  getRelationCustomer
} from '@/api/wms-stock'
import DonMessage from '@/utils/message'
import { dateFormat1, dateTimeFormat } from '@/utils/util'
import shengShiXian from '@/components/common/shengShiXian.vue'
export default {
  name: 'BasicMeterial',
  components: { shengShiXian },
  data () {
    return {
      dateTimeFormat: dateTimeFormat,
      searchForm: {
        pageNo: 1,
        pageSize: 20
      },
      businessList: [
        {
          value: '1',
          label: '入库计划'
        },
        {
          value: '2',
          label: '出库计划'
        }
      ],
      enableList: [
        {
          value: '1',
          label: '启用'
        },
        {
          value: '2',
          label: '停用'
        }
      ],
      checkList: [
        {
          value: '1',
          label: '校验'
        },
        {
          value: '2',
          label: '不校验'
        }
      ],
      RKData: [],
      huowuOptions: [],
      addForm: {
      },
      title: '',
      tableList: [],
      total: 0,
      dialogVisible: false,
      rules: {
        // businessType: [
        //   { required: true, message: '请选择业务类型', trigger: 'change' }
        // ],
        // enableStatus: [
        //   { required: true, message: '请选择启用状态', trigger: 'change' }
        // ],
        // productType: [
        //   { required: true, message: '请选择货物类型', trigger: 'change' }
        // ],
        // planWeight: [
        //   { required: true, message: '请输入计划量', trigger: 'change' }
        // ],
        // deliveryCompanyName: [
        //   { required: true, message: '请选择发货单位名称', trigger: 'change' }
        // ],
        // receiveCompanyName: [
        //   { required: true, message: '请选择收货单位名称', trigger: 'change' }
        // ],
        // checkLoad: [
        //   { required: true, message: '请选择是否校验装卸', trigger: 'change' }
        // ],
        // 业务类型
        businessType: [
          { required: true, message: '请选择业务类型', trigger: ['change', 'blur'] }
        ],
        // 启用状态
        enableStatus: [
          { required: true, message: '请选择启用状态', trigger: ['change', 'blur'] }
        ],
        // 货物类型
        productType: [
          { required: true, message: '请选择货物类型', trigger: ['change', 'blur'] }
        ],
        // 计划量
        planWeight: [
          { required: true, message: '请输入计划量', trigger: ['change', 'blur'] }
        ],
        // 发货单位名称
        deliveryCompanyName: [
          { required: true, message: '请选择发货单位名称', trigger: ['change', 'blur'] }
        ],
        // 发货联系人
        deliveryContact: [
          { required: true, message: '请输入发货联系人', trigger: ['change', 'blur'] },
          { min: 1, max: 20, message: '长度在 1-20 个字符', trigger: ['change', 'blur'] }
        ],
        // 发货电话
        deliveryPhone: [
          { required: true, message: '请输入发货电话', trigger: ['change', 'blur'] },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: ['change', 'blur'] }
        ],
        // 发货地址
        deliveryAddress: [
          { required: true, message: '请输入发货详细地址', trigger: ['change', 'blur'] },
          { min: 1, max: 100, message: '长度在 1-100 个字符', trigger: ['change', 'blur'] }
        ],
        // 收货单位名称
        receiveCompanyName: [
          { required: true, message: '请选择收货单位名称', trigger: ['change', 'blur'] }
        ],
        // 收货联系人
        receiveContact: [
          { required: true, message: '请输入收货联系人', trigger: ['change', 'blur'] },
          { min: 1, max: 20, message: '长度在 1-20 个字符', trigger: ['change', 'blur'] }
        ],
        // 收货电话
        receivePhone: [
          { required: true, message: '请输入收货电话', trigger: ['change', 'blur'] }
          // { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: ['change', 'blur'] }
        ],
        // 收货地址
        receiveAddress: [
          { required: true, message: '请输入收货详细地址', trigger: ['change', 'blur'] },
          { min: 1, max: 100, message: '长度在 1-100 个字符', trigger: ['change', 'blur'] }
        ],
        // 是否校验装卸
        checkLoad: [
          { required: true, message: '请选择是否校验装卸', trigger: ['change', 'blur'] }
        ],
        // 开始时间
        beginDate: [
          { required: true, message: '请选择开始时间', trigger: ['change', 'blur'] }
        ],
        // 截止时间
        endDate: [
          { required: true, message: '请选择截止时间', trigger: ['change', 'blur'] }
        ]
      },
      addBtnShow: true,
      changeBtnShow: false,
      addLoading: false,
      selectRows: [],
      selectRowsInfo: [],
      // 按钮
      btnFlg: [],
      btnIdArr: [
        '00ZP00GB001',
        '00ZP00GB002',
        '00ZP00GB003',
        '00ZP00GB004',
        '00ZP00GB005',
        '00ZP00GB006',
        '00ZP00GB007',
        '00ZP00GB008'
      ],
      h: '',
      transportVisible: false,
      laYunDataList: [],
      qishidi: {},
      mudidi: {}
    }
  },
  created () {
    this.getRelationCustomerS()
    this.findPlanOrderList()
    this.getVirtualBalingLists()
  },
  mounted () {
    this.btnFlg = getBtn(this.btnIdArr, '/basicMaterial')
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 165 + 'px'
  },
  methods: {
    // 地区选中
    handleChange (value) {
      if (value) {
        this.qishidi.provinceCode = value[0].areaCode
        this.qishidi.cityCode = value[1].areaCode
        this.qishidi.areaCode = value[2].areaCode
        this.qishidi.provinceName = value[0].name
        this.qishidi.cityName = value[1].name
        this.qishidi.areaName = value[2].name
      }
    },
    // 地区选中
    handleChange1 (value) {
      if (value) {
        this.mudidi.provinceCode = value[0].areaCode
        this.mudidi.cityCode = value[1].areaCode
        this.mudidi.areaCode = value[2].areaCode
        this.mudidi.provinceName = value[0].name
        this.mudidi.cityName = value[1].name
        this.mudidi.areaName = value[2].name
      }
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          this.RKData = res
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 货物类型
    getVirtualBalingLists () {
      getVirtualBalingList()
        .then(res => {
          // window.localStorage.setItem('HwInfos', JSON.stringify(res))
          let productArr = []
          res.forEach(item => {
            let obj = {}
            obj.id = item.productType
            obj.name = item.productTypeName
            productArr.push(obj)
          })
          const ress = new Map()
          let arrNew = productArr.filter((arr) => !ress.has(arr.id) && ress.set(arr.id, 1))
          this.huowuOptions = arrNew
        })
        .catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
    },
    findPlanOrderList () {
      findPlanOrderList(this.searchForm)
        .then(res => {
          console.log(res)
          res.list.forEach(item => {
            item.createTime = dateFormat1(item.createTime)
            item.updateTime = dateFormat1(item.updateTime)
          })
          this.tableList = res.list
          this.total = res.total
        })
        .catch(err => {
          DonMessage.error(err)
        })
    },
    searchFn () {
      this.findPlanOrderList()
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchForm.pageSize = val
      this.findPlanOrderList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchForm.pageNo = val
      this.findPlanOrderList()
    },
    rowClick (row, col, event) {
      this.selectRows[0] = row
      this.$refs.table.toggleRowSelection(row)
    },
    handleSelectionChange (val) {
      this.selectRows = val.map(item => item.id)
      this.selectRowsInfo = val
    },
    saveFn () {
      if (!this.qishidi) {
        this.$message.warning('请选择发货省市县！')
        return
      }
      if (!this.mudidi) {
        this.$message.warning('请选择收货省市县！')
        return
      }
      var timestamp1 = this.addForm.beginDate
      let timestamp2 = this.addForm.endDate
      if (timestamp1 > timestamp2) {
        this.$message.warning('截止时间需要大于开始时间时间')
        return
      }
      // 发货地
      this.addForm.deliveryProvinceCode = this.qishidi.provinceCode
      this.addForm.deliveryCityCode = this.qishidi.cityCode
      this.addForm.deliveryAreaCode = this.qishidi.areaCode
      this.addForm.deliveryProvinceName = this.qishidi.provinceName
      this.addForm.deliveryCityName = this.qishidi.cityName
      this.addForm.deliveryAreaName = this.qishidi.areaName

      // 收货地
      this.addForm.receiveProvinceCode = this.mudidi.provinceCode
      this.addForm.receiveCityCode = this.mudidi.cityCode
      this.addForm.receiveAreaCode = this.mudidi.areaCode
      this.addForm.receiveProvinceName = this.mudidi.provinceName
      this.addForm.receiveCityName = this.mudidi.cityName
      this.addForm.receiveAreaName = this.mudidi.areaName
      this.$refs.addForm.validate(valid => {
        if (valid) {
          if (this.addBtnShow) {
            this.addLoading = true
            addPlanOrder(this.addForm)
              .then(res => {
                console.log(res)
                this.dialogVisible = false
                this.findPlanOrderList()
                this.initAddForm()
                DonMessage.success('添加成功')
              })
              .catch(err => {
                this.addLoading = false
                console.log(err)
                DonMessage.error(err.message)
              })
          } else {
            this.addLoading = true
            updatePlanOrder(this.addForm)
              .then(res => {
                console.log(res)
                this.dialogVisible = false
                this.findPlanOrderList()
                this.initAddForm()
                DonMessage.success('修改成功')
              })
              .catch(err => {
                this.addLoading = false
                console.log(err)
                DonMessage.error(err.message)
              })
          }
        } else {
          this.addLoading = false
        }
      })
    },
    resetForm () {
      this.searchForm.placeOfOrigin = ''
      this.searchForm.productType = ''
      this.searchForm.specification = ''
      this.searchForm.model = ''
      // this.searchForm.length = ''
      this.findPlanOrderList()
    },
    addMaterial () {
      this.dialogVisible = true
      this.addLoading = false
      this.addBtnShow = true
      this.changeBtnShow = false
      this.title = '新增'
      this.mudidi = {}
      this.qishidi = {}
      this.$nextTick(() => {
        this.$refs['addForm'].clearValidate()
      })
    },
    editMaterial (row) {
      this.addForm = JSON.parse(JSON.stringify(row))
      this.qishidi.provinceCode = row.deliveryProvinceCode
      this.qishidi.cityCode = row.deliveryCityCode
      this.qishidi.areaCode = row.deliveryAreaCode
      this.qishidi.provinceName = row.deliveryProvinceName
      this.qishidi.cityName = row.deliveryCityName
      this.qishidi.areaName = row.deliverAreaName
      this.qishidi.id = 1
      this.mudidi.provinceCode = row.receiveProvinceCode
      this.mudidi.cityCode = row.receiveCityCode
      this.mudidi.areaCode = row.receiveAreaCode
      this.mudidi.provinceName = row.receiveProvinceName
      this.mudidi.cityName = row.receiveCityName
      this.mudidi.areaName = row.receiveAreaName
      this.mudidi.id = 1
      this.dialogVisible = true
      this.addLoading = false
      this.addBtnShow = false
      this.changeBtnShow = true
      this.title = '修改'
    },
    initAddForm () {
      this.addForm = {}
    },
    close () {
      this.dialogVisible = false
      this.initAddForm()
    },
    delMaterial (numFlag, row) {
      if (numFlag == 1) {
        if (this.selectRows.length < 1) {
          DonMessage.error('请先选择要删除的数据')
          return
        }
        this.$confirm('确定删除选中的数据？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(() => {
        // let selected = this.selectRows.join(',')
          let selected = this.selectRows
          deletePlanOrder({
            ids: selected
          })
            .then(res => {
              console.log(res)
              this.findPlanOrderList()
            })
            .catch(err => {
              DonMessage.error(err)
            })
        })
      } else {
        this.$confirm('确定删除选中的数据？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(() => {
          let selected = []
          selected.push(row.id)
          deletePlanOrder({
            ids: selected
          })
            .then(res => {
              console.log(res)
              this.findPlanOrderList()
            })
            .catch(err => {
              DonMessage.error(err)
            })
        })
      }
    },
    // 点击停用/启用
    qiYongClick (row) {
      let qiYongId = row.id
      let qiYongFlg = row.enableStatus
      let qiText = row.enableStatus == 1 ? '停用' : '启用'
      if (qiYongFlg == '1') {
        qiYongFlg = '2'
      } else if (qiYongFlg == '2') {
        qiYongFlg = '1'
      }
      this.getQiYong(qiYongId, qiYongFlg, qiText)
    },
    // 启用接口
    getQiYong (id, enableStatus, qiText) {
      this.$confirm('是否进行' + qiText + '操作', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        enablePlanOrder({
          id: id,
          enableStatus: enableStatus
        }).then(res => {
          this.$message.success('操作成功')
          this.findPlanOrderList()
        }).catch(err => {
          this.$message.error(err.message)
        })
      })
    },
    // 点击拉运量
    transportFn (row) {
      const loading = this.$loading({
        lock: true,
        text: '加载中...'
      })
      findSaForPlanList({
        id: row.id
      }).then(res => {
        this.laYunDataList = res
        loading.close()
        this.transportVisible = true
      }).catch(err => {
        loading.close()
        DonMessage.error(err.message)
      })
    },
    transportClose () {
      this.transportVisible = false
    }
  }
}
</script>

<style scoped lang="less">
.searchBtnBox {
  margin-left: 10px;
}
.addinpBox .el-input {
  width: 210px;
}
.demo-form-inline .el-select {
  width: 210px;
}

/deep/ .diqu .el-form-item__content .el-input__inner{
  width: 212px;
    height: 25px;
 }
 /deep/.el-form--inline .diqu{
 display: inline-block;
 }
/deep/.el-form--inline .diqu .el-form-item__content{
 display: inline-block;
}
</style>
